import { toast } from "react-toastify";
import { Send } from "../services/service.api";
import { API } from "../services/service.api";


/**
 * Upload le fichier d'attestation d'ordre des médecins sur le serveur.
 * @param {File} file - Le fichier sélectionné par l'utilisateur
 * @returns {Promise<string|null>} - L'ID du fichier uploadé, ou null en cas d'erreur
 */
/** "Attestation d'ordre - Dr Awa Ouedraogo.pdf": what the Medic'help team sees instead of "scan_0001.pdf". */
export function attestationName(demande, fileName = "") {
    const ext = (fileName.match(/\.([a-z0-9]{2,4})$/i)?.[1] || "pdf").toLowerCase();
    const who = [demande?.prenom, demande?.nom].map((v) => (v || "").trim()).filter(Boolean).join(" ");
    const base = demande?.type === "CABINET"
        ? `Justificatif du cabinet - ${(demande?.cabinet || who || "").trim()}`
        : `Attestation d'ordre${who ? ` - Dr ${who}` : ""}`;
    return `${base.replace(/[/\\:*?"<>|]/g, "-").trim()}.${ext}`;
}

async function uploadAttestation(file, demande) {
    const formData = new FormData();
    formData.append("file", file, attestationName(demande, file.name));
    const response = await fetch(API + "/demande/upload-attestation", {
        method: "POST",
        body: formData,
    });
    const res = await response.json();
    if (res.status === "success" && res.file_id) {
        return res.file_id;
    }
    throw new Error(res.message || "Échec de l'upload du fichier d'attestation.");
}


/**
 * Soumet une nouvelle demande d'inscription (médecin, ou cabinet si demande.type === "CABINET").
 * Étape 1 : Upload de l'attestation d'ordre → obtention du file_id.
 * Étape 2 : Envoi du formulaire JSON avec l'attestation_file_id.
 *
 * @param {Object} demande - Les données du formulaire
 * @param {File|null} attestationFile - Le justificatif sélectionné (absent possible pour un cabinet)
 */
export async function newDemande(demande, attestationFile) {
    try {
        // Étape 1 : Upload de l'attestation (facultative pour un cabinet)
        let fileId = "";
        if (attestationFile) {
            toast.info("Envoi du justificatif en cours…");
            fileId = await uploadAttestation(attestationFile, demande);
        }

        // Étape 2 : Envoi de la demande avec la référence fichier
        const payload = { ...demande, attestation_file_id: fileId };
        const res = await Send("/demande/new", payload, true, '');

        if (res["status"] === "success") {
            toast.success(res["message"]);
            document.getElementById('successMessage').classList.remove('hidden');
            setTimeout(() => {
                window.location.reload();
            }, 2500);
        } else if (res["status"] === "warning") {
            toast.warning(res["message"]);
        } else {
            toast.error(res["message"] || "Rien n'a été sauvegardé");
        }
        return res["message"];
    } catch (error) {
        toast.error(error.message || "Erreur lors de la soumission de la demande.");
    }   
}